// extracted by mini-css-extract-plugin
module.exports = {"header-search-desktop-input__input":"HeaderSearchDesktopInput_header-search-desktop-input__input__E7M7f"};